<!-- SRV list — layout aligned with Project Management (new-project-list) -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <!-- Header -->
  <div class="mb-8">
    <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div>
        <h1 class="mb-2 text-3xl font-bold text-gray-900">{{ "SRV Management" | translate }}</h1>
        <p class="text-gray-600">Site Receipt Vouchers for your organization</p>
      </div>
      <div class="flex flex-wrap gap-4">
        <div class="rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
          <div class="flex items-center gap-3">
            <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
              <svg class="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                ></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Total SRV</p>
              <p class="text-lg font-semibold text-gray-900">{{ dataSource.data.length }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search & filters -->
  <div class="mb-8 rounded-2xl border border-gray-200 bg-white p-6 shadow-lg">
    <div class="flex flex-col gap-4 lg:flex-row">
      <div class="flex-1">
        <div class="relative">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search vouchers by code, project, or item…"
            class="block w-full rounded-xl border border-gray-300 bg-gray-50 py-3 pl-10 pr-3 leading-5 transition-all duration-200 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-200"
            (input)="applyFilter($event)"
          />
        </div>
      </div>
      <div class="lg:w-64">
        <select
          class="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-gray-700 transition-all duration-200 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-200"
          (change)="filterByStatus($event)"
          [value]="statusFilter"
        >
          <option value="">All statuses</option>
          <option value="submitted">Submitted</option>
        </select>
      </div>
      <div class="flex flex-col gap-3 sm:flex-row">
        <a
          routerLink="/home/add-srv"
          class="inline-flex transform items-center justify-center rounded-xl border border-transparent bg-blue-600 px-6 py-3 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:scale-105 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:scale-95"
        >
          <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          {{ "ADD_SRV" | translate }}
        </a>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 shadow-sm transition-all duration-200 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          (click)="fetchData()"
        >
          Refresh
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-lg">
    <div class="border-b border-gray-200 bg-gray-50 px-6 py-4">
      <h2 class="text-lg font-semibold text-gray-900">SRV overview</h2>
      <p class="mt-1 text-sm text-gray-600">Manage Site Receipt Vouchers for your projects</p>
    </div>

    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="srNo">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            #
          </th>
          <td mat-cell *matCellDef="let row; let i = index" class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
            {{ i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="reference_code">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Voucher
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">{{ row.reference_code }}</td>
        </ng-container>
        <ng-container matColumnDef="project_name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Project
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">{{ row.project_name_snapshot }}</td>
        </ng-container>
        <ng-container matColumnDef="domain">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Domain
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">{{ row.domain }}</td>
        </ng-container>
        <ng-container matColumnDef="voucher_date">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Receipt date
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
            {{ row.voucher_date | date: "mediumDate" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="item_summary">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Items
          </th>
          <td mat-cell *matCellDef="let row" class="px-6 py-4 text-sm text-gray-900">{{ row.item_summary }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Status
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">{{ row.status }}</td>
        </ng-container>
        <ng-container matColumnDef="linked_siv">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Linked SIV
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
            {{ row.linked_siv_reference_code || "—" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="created_by_name">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Created by
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm text-gray-900">{{ row.created_by_name || "—" }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="bg-gray-50 px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
          >
            Actions
          </th>
          <td mat-cell *matCellDef="let row" class="whitespace-nowrap px-6 py-4 text-sm font-medium">
            <div class="flex items-center gap-1">
              <button
                *ngIf="!row.linked_siv_id"
                type="button"
                class="inline-flex items-center rounded-lg border border-transparent p-2 text-blue-600 transition-colors duration-200 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                (click)="generateSiv(row)"
                matTooltip="Generate SIV from this SRV"
              >
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  ></path>
                </svg>
              </button>
              <button
                type="button"
                class="inline-flex items-center rounded-lg border border-transparent p-2 text-red-600 transition-colors duration-200 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500"
                (click)="deleteSrv(row)"
                matTooltip="Delete"
              >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                ></path>
              </svg>
            </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="transition-colors duration-150 hover:bg-gray-50"
        ></tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length === 0" class="py-12 text-center">
      <div class="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100">
        <svg class="h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
      </div>
      <h3 class="mb-2 text-lg font-medium text-gray-900">No SRV records found</h3>
      <p class="mb-6 text-gray-500">Get started by creating your first Site Receipt Voucher.</p>
      <a
        routerLink="/home/add-srv"
        class="inline-flex items-center rounded-xl border border-transparent bg-blue-600 px-6 py-3 text-sm font-medium text-white transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        {{ "ADD_SRV" | translate }}
      </a>
    </div>

    <div class="border-t border-gray-200 bg-gray-50 px-6 py-4">
      <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons class="bg-transparent"></mat-paginator>
    </div>
  </div>
</div>
